<div class="fx-row align-items-center justify-content-between">
  <span class="text light">{{'DOCUMENT.CLASS' | translate}}</span>
  <div class="fx-row align-items-center justify-content-end" *ngIf="showEye">
    <mat-icon [class.shown]="shown" class="visibility-icon ml-10" fontSet="material-icons-outlined">{{shown ?
      'visibility' :
      'visibility_off'}}</mat-icon>
  </div>
</div>
<div class="fx-row fx-wrap w-100 align-items-center justify-content-between mt-8">
  <span class="text fx-flex">{{documentClass ? ('DOCUMENT_CLASSES.'+documentClass | translate) :
    '-'}}</span>
  <app-metadata-confidence *ngIf="documentClass" class="ml-20" [value]="getConfidence()"></app-metadata-confidence>
</div>